import { PAGINATION_RECORD_PER_PAGE } from "MainApp/features/App/constants";

export const USER_POSTS_PER_PAGE = PAGINATION_RECORD_PER_PAGE;
export const USERS_LIST_PER_PAGE = PAGINATION_RECORD_PER_PAGE;
export const BLOCKED_USERS_LIST_PER_PAGE = PAGINATION_RECORD_PER_PAGE;
export const BIO_MAXIMUM_LENGTH = 150;
export const EDIT_FIELDS_MAXIMUM_LENGTH = 25;